import React, { Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromRaw,
  convertFromHTML,
  RichUtils,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import $, { event } from "jquery";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import { ToastContainer, toast } from "react-toastify";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import { tr } from "date-fns/locale";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import cssu

export default class BrowseContent extends Component {
  constructor(props) {
    super(props);

    window.ContentLibraryController = this;

    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false,
        hideDeletePublishPopup: false,
        hideDeleteUnpublishPopup: false,
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          if (this.state.type == "content") {
            this.deleteContent(this.state.propsId);
          } else {
            this.deleteFolder(this.state.propsId);
          }
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    //for delete dialog component ok click
    this.publishButtons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.publish();
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePublishPopup: false,
            disabled: false,
          });
        },
      },
    ];

    this.unpublishButtons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.unPublish();
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeleteUnpublishPopup: false,
            disabled: false,
          });
        },
      },
    ];

    //for delete success
    this.deleteSuccessbuttons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.dialogInstance.hide();
          this.fetchContent();
          this.setState({ disabled: false });
        },
      },
    ];

    this.state = {
      sectionIds: new Set(),
      folderIds: new Set(),
      imageUrlUpload: false,
      dataStartedProcessing: false,
      disableSelectContentType: false,
      videoUrlUpload: false,
      editVideoUrlUpload: false,
      audioUrlUpload: false,
      showProgressBar: false,
      progressStatus: null,
      percentage: 0,
      hideChoseFile: false,
      docCharacterCount: 0,
      errorMsg: "",
      selectedOption: "uploadFileContent",
      uploadURLContent: false,
      imgContent: "",
      fileContentUpload: false,
      iconFileUpload: false,
      type: "",
      contentId: "",
      editorState: EditorState.createEmpty(),
      existingContentInfo: {
        documentSections: [],
        subFolderList: [],
        folderTitle: "Home",
      },
      folderId: "00000000-0000-0000-0000-000000000000",
      folderPathName: "Home",
      showNoData: false,
      addedFolderInfo: [],
      iconFile: "",
      iconFileNameDisplay: "",
      iconImage: false,
      imageContentType: false,
      videoContentType: false,
      audioContentType: false,
      textContentType: true,
      showAddFolderOverLay: false,
      showAddContentOverLay: false,
      documentList: [],
      showLoader: false,
      editedId: -1,
      languageList: [],
      language: "",
      hideDeletePopup: false,
      hideDeletePublishPopup: false,
      hideDeleteUnpublishPopup: false,
      published: false,
      disableUpload: false,
      disableDone: false,
      folderPath: [
        {
          id: "00000000-0000-0000-0000-000000000000",
          label: "Home",
          depth: 0,
        },
      ],
      firstSelectValue: 'admins',
      selectedAdmin: "admin"
    };

    // this.setDomEditorRef = ref => this.domEditor = ref;
    // this.focus = () => this.domEditor.curent
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.fileInput = [];
    this.newVersionInfo =
      "This Version is published. To continue making changes without publishing the newer changes, please save a version and continue working on it.";
  }
  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      thisController.fetchContent();
      // thisController.fetchYoursContent();
    }, 300);
  }

  checkforContentIds = (type, contentId) => {
    if (type == "folders" && this.state.folderIds.has(contentId)) {
      return true;
    } else if (type == "sections" && this.state.sectionIds.has(contentId)) {
      return true;
    }
    return false;
  };

  handleAddContent = (type, contentId) => {
    console.log("type", type);
    this.props.handleAddContentData(type, contentId);
  };

  addContentIds = (type, contentId) => {
    if (type == "folders") {
      if (this.state.folderIds.has(contentId)) {
        this.state.folderIds.delete(contentId);
      } else {
        this.state.folderIds.add(contentId);
      }
    } else if (type == "sections") {
      if (this.state.sectionIds.has(contentId)) {
        this.state.sectionIds.delete(contentId);
      } else {
        this.state.sectionIds.add(contentId);
      }
    }
    this.setState(this.state);
  };

  removeContentIds = (folderid) => {

    if (this.state.folderIds.has(folderid)) {
      this.state.folderIds.delete(folderid);
      this.setState(this.state);
    }
  }

  fetchYoursContent(updateFolderPath) {
    var fetchController = this;
    var scopeGroups = [];
    var selectedAdmin = fetchController.state.selectedAdmin;
    var userRole = fetchController.props.userRole;
    // var propsUrl = "/my-jeeva-api/content";
    // if (userRole == "Admin") {
    //   propsUrl = "/my-jeeva-api/admin-content";
    // }
    var treatmentId = localStorage.getItem("treatmentId");
    console.log(" treatment id from local : ", treatmentId, userRole);
    scopeGroups.push(treatmentId);
    $.ajax({
      url: "/my-jeeva-api/library-module-admin/content",
      async: true,
      method: "GET",
      data: {
        scopeGroup: treatmentId,
        scopeGroups: JSON.stringify(scopeGroups),
        scope: "TREATMENT",
        parentFolderId: fetchController.state.folderId,
      },
      success: function (res) {
        if (res.success == true) {
          document.getElementById("imageContentUrl").value = "";
          document.getElementById("videoContentUrl").value = "";
          document.getElementById("audioContentUrl").value = "";
          document.getElementById("imageCaptionId").value = "";
          document.getElementById("videoCaptionId").value = "";
          document.getElementById("audioCaptionId").value = "";
          document.getElementById("imageContentId").value = null;
          document.getElementById("videoContentId").value = null;
          document.getElementById("audioContentId").value = null;
          fetchController.state.disableUpload = false;
          fetchController.setState(fetchController.state);

          fetchController.state.fileContent = undefined;
          if (res.result.length == 0) {
            fetchController.state.showNoData = true;
            fetchController.state.existingContentInfo = res.result;
            fetchController.setState(fetchController.state);
          } else {
            fetchController.state.fileContentUpload = false;
            // fetchController.state.iconFileUpload=false
            fetchController.state.imageUrlUpload = false;
            fetchController.state.videoUrlUpload = false;
            fetchController.state.editVideoUrlUpload = false;
            fetchController.state.audioUrlUpload = false;
            fetchController.state.showNoData = false;
            fetchController.state.existingContentInfo = res.result;
            fetchController.state.showAddContentOverLay = false;
            fetchController.state.showAddFolderOverLay = false;
            fetchController.state.showpreviewModeOverLay = false;
            fetchController.state.showProgressBar = false;
            fetchController.state.published = res.result.published;
            console.log(
              "The state of published in fetchContent :" +
              fetchController.state.published
            );
            fetchController.maxOrder = res.result.maxOrder;
            if (updateFolderPath) {
              var folderPathIdList = fetchController.state.folderPath.map(
                (fp) => {
                  return fp.id;
                }
              );
              if (!folderPathIdList.includes(fetchController.state.folderId)) {
                fetchController.state.folderPath.push({
                  id: fetchController.state.folderId,
                  label: res.result.folderTitle,
                  depth: fetchController.state.folderPath.length,
                });
              }
            }
            fetchController.setState(fetchController.state);
          }
        }
      },
    });
  }

  fetchContent(updateFolderPath) {
    var fetchController = this;
    var scopeGroups = [];
    var userRole = fetchController.props.userRole;
    var propsUrl = "/my-jeeva-api/library-module-admin/content";
    if (userRole == "Admin") {
      propsUrl = "/my-jeeva-api/library-module-admin/content";
    }
    var treatmentId = localStorage.getItem("treatmentId");
    console.log(" treatment id from local : ", treatmentId, userRole);
    scopeGroups.push(treatmentId);

    var data = {
      scopeGroup: treatmentId,
      scopeGroups: JSON.stringify(scopeGroups),
      scope: "TREATMENT",
      parentFolderId: fetchController.state.folderId
    };

    if (propsUrl === "/my-jeeva-api/selected-admins-content") {
      var userDetails = JSON.parse(localStorage.getItem("user_details"));
      var userId = userDetails.userId; 
      var selectedAdmin = fetchController.state.selectedAdmin;
      data.userId = userId;
      data.selectedAdmin = selectedAdmin;
    }
    $.ajax({
      url: propsUrl,
      async: true,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: data,
      success: function (res) {
        if (res.success == true) {
          document.getElementById("imageContentUrl").value = "";
          document.getElementById("videoContentUrl").value = "";
          document.getElementById("audioContentUrl").value = "";
          document.getElementById("imageCaptionId").value = "";
          document.getElementById("videoCaptionId").value = "";
          document.getElementById("audioCaptionId").value = "";
          document.getElementById("imageContentId").value = null;
          document.getElementById("videoContentId").value = null;
          document.getElementById("audioContentId").value = null;
          fetchController.state.disableUpload = false;
          fetchController.setState(fetchController.state);

          fetchController.state.fileContent = undefined;
          if (res.result.length == 0) {
            fetchController.state.showNoData = true;
            fetchController.state.existingContentInfo = res.result;
            fetchController.setState(fetchController.state);
          } else {
            fetchController.state.fileContentUpload = false;
            // fetchController.state.iconFileUpload=false
            fetchController.state.imageUrlUpload = false;
            fetchController.state.videoUrlUpload = false;
            fetchController.state.editVideoUrlUpload = false;
            fetchController.state.audioUrlUpload = false;
            fetchController.state.showNoData = false;
            fetchController.state.existingContentInfo = res.result;
            fetchController.state.showAddContentOverLay = false;
            fetchController.state.showAddFolderOverLay = false;
            fetchController.state.showpreviewModeOverLay = false;
            fetchController.state.showProgressBar = false;
            fetchController.state.published = res.result.published;
            console.log(
              "The state of published in fetchContent :" +
              fetchController.state.published
            );
            fetchController.maxOrder = res.result.maxOrder;
            if (updateFolderPath) {
              var folderPathIdList = fetchController.state.folderPath.map(
                (fp) => {
                  return fp.id;
                }
              );
              if (!folderPathIdList.includes(fetchController.state.folderId)) {
                fetchController.state.folderPath.push({
                  id: fetchController.state.folderId,
                  label: res.result.folderTitle,
                  depth: fetchController.state.folderPath.length,
                });
              }
            }
            fetchController.setState(fetchController.state);
          }
        }
      },
    });
    // }

  }

  fetchStream(mediaId) {
    var fetchController = this;

    $.ajax({
      url: "/my-jeeva-api/stream",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        mediaId: mediaId,
      },
      success: function (res) {
        if (res.success == true) {
          console.log("done with streaming");
        }
      },
    });
  }

  fetchMedia(mediaId) {
    var fetchController = this;

    $.ajax({
      url: "/my-jeeva-api/media",

      method: "GET",

      data: {
        mediaId: mediaId,
      },
      success: function (res) {
        fetchController.state.mediaUrl = res;
        fetchController.setState(fetchController.state);
      },
    });
  }

  sectionTemplate(section) {
    switch (section.type) {
      case "TEXT":
        const htmlContent = section.textContent;
        const modifiedHtmlContent = htmlContent.replace(
          /background-color:\s*[^;]+;/g,
          "background-color: white;"
        );
        return (
          <div className="col-sm-9">
            <div
              style={{
                marginTop: "1vw",
                marginBottom: "1vw",
                borderRadius: "10px",
                padding: "6px",
                height: "auto",
                backgroundColor: "inherit",
                maxWidth: "50vw",
              }}
              className="textarea"
              dangerouslySetInnerHTML={{ __html: modifiedHtmlContent }}
            ></div>
          </div>
        );
      case "IMAGE":
        var mediaUrl;
        if (section.mediaUrl != null) {
          mediaUrl = section.mediaUrl;
        } else if (section.mediaId != null) {
          mediaUrl = "/my-jeeva-api/media/" + section.mediaId;
        } else {
          mediaUrl = "/assets/images/not-available.jpg";
        }
        return (
          // <div>
          //     <div className='col-sm-2'>
          //         <label style={{ marginLeft: '1vw', marginTop: '1vw' }}>{section.caption}</label>
          //     </div>
          <div className="col-sm-9">
            <div
              className="sectionImage"
              id={"sectionImage" + section.id}
              style={{
                borderRadius: "10px",
              }}
            >
              <img
                src={mediaUrl}
                style={{
                  width: "25rem",
                  height: "30rem",
                  textDecoration: "underline",
                  color: "blue",
                  cursor: "pointer",
                }}
              ></img>
            </div>
          </div>
          // </div>
        );
      case "VIDEO":
        var mediaUrl;
        if (section.mediaUrl != null) {
          mediaUrl = section.mediaUrl;
        } else if (section.mediaId != null) {
          mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
        } else {
          mediaUrl = "/assets/images/not-available.jpg";
        }
        var youtubeVideoPattern = new RegExp(
          /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
        );
        return (
          <div className="col-sm-9">
            {!youtubeVideoPattern.test(mediaUrl) ? (
              <div
                className="sectionVideo"
                id={"sectionVideo" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <video
                  width="350"
                  height="300"
                  controls
                  disablePictureInPicture
                  controlsList="nodownload"
                  style={{
                    maxWidth: "50vw",
                    textDecoration: "underline",
                    color: "blue",
                    cursor: "pointer",
                  }}
                >
                  <source
                    src={mediaUrl}
                    type="video/mp4"
                    style={{
                      maxWidth: "50vw",
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                    }}
                  />
                </video>
              </div>
            ) : (
              <div
                className="sectionVideo"
                id={"sectionVideo" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <ReactPlayer
                  url={mediaUrl}
                  className="sectionVideoYoutube"
                  // width="350"
                  // height="300"
                  controls
                  style={{
                    width: "35rem",
                    height: "30rem",
                    textDecoration: "underline",
                    color: "blue",
                    cursor: "pointer",
                  }}
                />
              </div>
            )}
          </div>

          // </div>
        );
      case "AUDIO":
        var mediaUrl;
        if (section.mediaUrl != null) {
          mediaUrl = section.mediaUrl;
        } else if (section.mediaId != null) {
          mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
        } else {
          mediaUrl = "/assets/images/not-available.jpg";
        }
        var onlineMusicAppPattern = new RegExp(
          /^(?:https?:\/\/)?(?:www\.)?(?:soundcloud\.com|snd\.sc)\/([a-zA-Z0-9-_]+)\/(?:(?:sets\/)?([a-zA-Z0-9-_]+)|(?:[^\/?]+))(?:\?.*)?$/
        );

        return (
          <div className="col-sm-9">
            {!onlineMusicAppPattern.test(mediaUrl) ? (
              <div
                className="sectionAudio"
                id={"sectionAudio" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <audio
                  controlsList="nodownload"
                  controls
                  style={{ width: "23rem" }}
                >
                  <source
                    src={mediaUrl}
                    type="audio/mpeg"
                    style={{
                      maxWidth: "23rem",
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                    }}
                  />
                </audio>
              </div>
            ) : (
              <div
                className="sectionAudio"
                id={"sectionAudio" + section.id}
                style={{
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <ReactPlayer
                  className="sectionOnline-Audio"
                  url={mediaUrl}
                  controls
                  controlsList="nodownload"
                // style={{ width: "30rem", 
                // marginLeft:"0px",
                // height:"30rem", }}
                />
              </div>
            )}
          </div>
        );
    }
  }

  closeAddContentOverLay = () => {
    this.state.showAddContentOverLay = false;
    this.setState(this.state);
  };

  onFolderNameClicked(id, depth) {
    var newPath = [];
    var folder;
    for (var i = 0; i < this.state.folderPath.length; i++) {
      folder = this.state.folderPath[i];
      if (folder.depth < depth) {
        newPath.push(folder);
      }
    }
    this.state.folderPath = newPath;
    this.onFolderClick(id);
  }

  onFolderClick(id) {
    this.state.folderId = id;
    this.setState(this.state);

    this.fetchContent(true);
  }

  handleFirstSelectChange = (event) => {
    this.setState({ firstSelectValue: event.target.value });
  }

  handleAdmins = (event) => {
    var thisController = this;
    thisController.state.selectedAdmin = event.target.value;
    thisController.setState( thisController.state);
    thisController.fetchContent();
  }

  render() {
    const { editorState } = this.state;
    const { firstSelectValue } = this.state;
    const { userRole } = this.props;

    return (
      <div id="contentLibForTreatmentTab" >
        {/* <Loader
                      type="TailSpin"
                      color="#282a65"
                      visible={this.state.showLoader}
                      height={300}
                      width={50}
                      style={{ textAlign: 'center' }} /> */}

        <div style={{ display: !this.state.showLoader ? "block" : "none" }}>
          <link rel="stylesheet" href="assets/css/modal-style.css" />

          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          {/* for toaster */}
          <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

          {/* for dialog component */}
          <link href="./assets/css/ej2-base.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="./assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />

          {/* <ToastContainer className="Toast-at-center" /> */}

          <div className="content-header">
            <div className="row">
              <div className="col-sm-6">
                <div style={{ display: "flex" }}>
                  <select className="form-control"
                    value={firstSelectValue}
                    onChange={this.handleFirstSelectChange}
                    style={{ display: userRole == "Admin" ? "inline-block" : "none", marginLeft: "3vw", marginBottom: "1vw", width: "12vw" }}>
                    <option value="admins">Your's Admin</option>
                    <option value="jeevalibrary">MyJeeva Library</option>
                  </select>

                  {firstSelectValue === 'admins' && (
                    <select
                      className="form-control"
                      style={{ display: userRole == "Admin" ? "inline-block" : "none", marginLeft: '3vw', width: "12vw" }}
                      onChange={this.handleAdmins}
                      value={this.state.selectedAdmin}
                    >
                      <option value="admin">Admin</option>
                      <option value="healthSystemAdmin">Healthsystem Admin</option>
                      <option value="hospitalAdmin">Hospital Admin</option>
                      <option value="serviceLineAdmin">ServiceLine Admin</option>
                    </select>
                  )}
                </div>

                <h6
                  className="nav-item"
                  style={{
                    color: "#282a65",
                    marginTop: "1vh",
                    marginLeft: "1vw",
                  }}
                >
                  Manage Content of {this.state.existingContentInfo.folderTitle}
                </h6>
              </div>
              <div className="col-sm-6" style={{ display: "flex", justifyContent: "end" }}>
                <h6 style={{ marginRight: "1.5rem" }} >{userRole == "Admin" ? "Admin's Content" : "Your Content"}</h6>
              </div>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card-body p-0 mb-25">
                    <div className="tab-content col-12 p-0">
                      <div className="tab-pane active show" id="tab_1">
                        <div className="card card-primary mt-3">
                          <div className="card-body raise-form">
                            <div className="row">
                              <div
                                className="col-sm-12"
                                align="center"
                                style={{
                                  display: this.state.showNoData
                                    ? "block"
                                    : "none",
                                  marginTop: "10%",
                                }}
                              >i
                                <div
                                  style={{
                                    width: "40%",
                                    fontSize: "22px",
                                    color: "#282a65",
                                    marginTop: "-50px",
                                  }}
                                >
                                  <h3
                                    className="m-0 page-title"
                                    style={{ textAlign: "center" }}
                                  >
                                    No content added yet!
                                  </h3>
                                  <br />
                                  <label>
                                    It seems there is no content added.
                                  </label>
                                  <br />
                                  <label>
                                    Please use below button to add content.
                                  </label>
                                </div>
                              </div>
                              <div className="row" style={{ display: "block" }}>
                                <h2
                                  className="page-title"
                                  style={{
                                    marginLeft: "1em",
                                    marginBottom: "1em",
                                    paddingTop: "0px",
                                  }}
                                >
                                  <img
                                    src="assets/images/folder.png"
                                    style={{
                                      paddingRight: "0px",
                                      height: "30px",
                                      width: "30px",
                                    }}
                                    content=""
                                  />
                                  {this.state.folderPath.map((el, i) => (
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        this.onFolderNameClicked(
                                          el.id,
                                          el.depth
                                        );
                                        if (userRole === "Provider") {
                                          this.props.handleChangeParentFolderId(
                                            el.id
                                          );
                                        }

                                      }}
                                    >
                                      {" / " + el.label}
                                    </a>
                                  ))}
                                </h2>
                              </div>
                              <div style={{ width: "100%" }}>
                                <div style={{ width: "75%%" }}>
                                  {this.state.existingContentInfo.documentSections.map(
                                    (section, i) => (
                                      <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
                                        <div style={{ paddingRight: "2rem" }}>
                                          {userRole == "Admin" && (
                                            <input
                                              // style={{ display: "flex", width: "2rem", height: "2rem" }}
                                              type="checkbox"
                                              className="custom-checkbox"
                                              checked={this.checkforContentIds(
                                                "sections",
                                                section.id
                                              )}
                                              onChange={(e) => {
                                                this.addContentIds(
                                                  "sections",
                                                  section.id
                                                );
                                                this.props.handleAddContentData(
                                                  "sections",
                                                  section.id
                                                );
                                              }}
                                            />
                                          )}
                                        </div>
                                        <div
                                          className="fontpreviewBox"
                                          style={{
                                            borderRadius: "1vw",
                                            marginTop: "1vw",
                                            boxShadow: "0 0 5px 0 #c2c4d2",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "40rem"
                                          }}
                                        >

                                          <div>
                                            <div
                                              className={
                                                section.caption != null ? "row" : ""
                                              }
                                            >
                                              <label
                                                style={{
                                                  display:
                                                    section.caption != null
                                                      ? "block"
                                                      : "none",
                                                  color: "rgb(40, 42, 101)",
                                                  marginTop: "1vw",
                                                  marginLeft: "2vw",
                                                  fontWeight: "430",
                                                  fontSize: "18px",
                                                }}
                                              >
                                                {section.caption}
                                              </label>
                                            </div>
                                            <div className="row" style={{ paddingLeft: "5rem" }}>
                                              {this.sectionTemplate(section)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>

                                {this.state.existingContentInfo.subFolderList.map(
                                  (el, i) => (
                                    <div key={i}>
                                      <div>
                                        <div>
                                          <div
                                            className="row"
                                            style={{
                                              padding: "1vw",
                                              borderRadius: "1vw",
                                              boxShadow: "0 0 5px 0 #c2c4d2",
                                              marginLeft: "0.8vw",
                                              marginTop: "1vw",
                                              marginRight: "-0.2vw",
                                              display: "flex",
                                              alignItems: "center"
                                            }}
                                          >
                                            <div style={{ marginRight: "4rem", display: "flex" }}>
                                              {userRole == "Admin" && (
                                                <input
                                                  // style={{ width: "2rem", height: "2rem", display: "flex", marginTop: "4rem" }}
                                                  type="checkbox"
                                                  className="custom-checkbox"
                                                  checked={this.checkforContentIds(
                                                    "folders",
                                                    el.id
                                                  )}
                                                  onChange={(e) => {
                                                    this.addContentIds(
                                                      "folders",
                                                      el.id
                                                    );
                                                    this.props.handleAddContentData(
                                                      "folders",
                                                      el.id
                                                    );
                                                  }}
                                                />
                                              )}
                                            </div>
                                            <div
                                              className="col-sm-1"
                                              style={{ marginRight: "2rem" }}
                                              onClick={() => {
                                                const id =
                                                  this.state.existingContentInfo
                                                    .subFolderList[i].id;

                                                if (userRole == "Provider") {
                                                  this.onFolderClick(id);
                                                  this.props.handleChangeParentFolderId(
                                                    id
                                                  );
                                                } else {
                                                  this.removeContentIds(id);
                                                  this.props.handleRemoveContentData(
                                                    "folders",
                                                    id
                                                  );
                                                  this.onFolderClick(id);
                                                }
                                              }}
                                              subFolderList
                                            >
                                              <div className="previewText image-container">
                                                <img
                                                  id="qr_code"
                                                  src={
                                                    "data:png;base64," +
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].icon
                                                  }
                                                  style={{
                                                    width: "9vw",
                                                    marginLeft: "-1vw",
                                                    height: "8vw",
                                                    borderRadius: "1vw",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </div>
                                            </div>

                                            <div
                                              className="col-sm-8"
                                              style={{ paddingLeft: "7rem" }}
                                            >
                                              <h3
                                                className="m-0 page-title"
                                                style={{
                                                  paddingBottom: "1vw",
                                                  paddingTop: "1vw",
                                                  border:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "1px solid #D2D4DC"
                                                      : "none",
                                                  borderRadius:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "6px"
                                                      : "none",
                                                }}
                                              >
                                                {
                                                  this.state.existingContentInfo
                                                    .subFolderList[i].label
                                                }
                                              </h3>

                                              <div
                                                className="textarea"
                                                // disabled={!this.state.user_editable}
                                                style={{
                                                  textAlign: "left",
                                                  height: "2.7em",
                                                  resize: "none",
                                                  paddingTop: "6px",
                                                  marginTop: "1vw",

                                                  border:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "1px solid #D2D4DC"
                                                      : "none",
                                                  borderRadius:
                                                    this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id ==
                                                      "" ||
                                                      this.state
                                                        .existingContentInfo
                                                        .subFolderList[i].id ==
                                                      this.state.editedId
                                                      ? "6px"
                                                      : "none",
                                                }}
                                                id={"descriptionId" + [i]}
                                                contentEditable={
                                                  !(this.state
                                                    .existingContentInfo
                                                    .subFolderList[i].id == ""
                                                    ? false
                                                    : this.state
                                                      .existingContentInfo
                                                      .subFolderList[i].id !=
                                                    this.state.editedId)
                                                    ? "plaintext-only"
                                                    : false
                                                }
                                              >
                                                {
                                                  this.state.existingContentInfo
                                                    .subFolderList[i]
                                                    .description
                                                }
                                              </div>
                                            </div>
                                            <br />
                                            <br />
                                          </div>
                                          <br />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/BrowseFromAdminContent.js